"use client";

import React, { useState } from "react";
import { usePathname } from "next/navigation";
import Sidebar from "@/components/ui/Sidebar";
import TopBar from "@/components/ui/TopBar";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import { UserSelectionProvider } from "@/components/context/UserSelectionContext";

// Pages that should NOT have Sidebar/TopBar
const PUBLIC_ROUTES = [
    "/login",
    "/setup",
    "/auth/gmail-callback",
    "/auth/google-connection-callback",
    "/auth/linkedin-callback",
    "/call-demo",
    "/call-testing",
    "/testing",
    "/campaigns/new",
];

interface ClientLayoutProps {
    children: React.ReactNode;
}

export default function ClientLayout({ children }: ClientLayoutProps) {
    const pathname = usePathname();

    // Check if current route is public (no sidebar/topbar needed)
    const isPublicRoute = PUBLIC_ROUTES.some((route) => pathname.startsWith(route));

    // For public routes, render children directly without layout
    if (isPublicRoute) {
        return <>{children}</>;
    }

    // For authenticated routes, wrap with ProtectedRoute and layout
    return (
        <UserSelectionProvider>
            <ProtectedRoute>
                <div className="flex h-screen bg-gray-50">
                    <Sidebar />
                    <div className="flex-1 flex flex-col overflow-hidden">
                        <TopBar />
                        <div className="flex-1 overflow-y-auto p-6">{children}</div>
                    </div>
                </div>
            </ProtectedRoute>
        </UserSelectionProvider>
    );
}
